<template>
  <div>
    <modals-container name="modal1" />
    <!--我的问卷-->
    <!--标题-->
    <p class="fav_mainHead">我的问卷</p>
    <!--内容-->
    <h5 class="none_ts" v-if="examList.length == 0" style="text-align: center;">
      <img src="@/assets/images/none_data.jpg" alt="">
    </h5>
    <div class="exam_con" v-if="examList.length > 0" v-for="item in examList" :key="item.id">
      <div class="exam_con_left">
        <img v-if="item.faceUri" :src="item.faceUri" class="exam_con_img"/>
        <img v-if="!item.faceUri || item.faceUri==''" src="@/assets/images/test_img.jpg" class="exam_con_img"/>
        <div>
          <p class="font_eighteen  mb13">{{item.title}}</p>
          <p>问卷题目数量: {{item.cntQuestion}}题</p>
          <p>开放时间: {{item.startDate}} 至 {{item.endDate}}</p>
          <p>得分: {{item.userScore}} &nbsp;&nbsp;&nbsp;&nbsp;所有人平均得分: {{item.avgScore}}</p>
        </div>
      </div>
      <div class="exam_con_right">
        <p class="font12  pr18">{{item.isUsed}}人次参与</p>
        <a v-if="getPaperState(item).code == '0' && item.canDuplication == '1'" href="javascript:;" class="exam_con_right_a1" @click="doQuestionnaire(item)">{{getPaperState(item).value}}</a>
        <a href="javascript:;" class="exam_con_right_a2" v-if="item.examIdFinish && item.examIdFinish!=''" @click="showQuizResult(item)">回答详情</a>
      </div>
    </div>
    <div v-if="examList.length > 0" class="zy_list_bottom">
      <dl>
        <dd>
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/我的考试-->
  </div>
</template>
<script>
  import { getCookie } from '@/store/cookies'
import Paginate from 'vuejs-paginate'
  import ModalBox from '@/components/common/modal/index.vue'
  import QuizResultContainer from '@/page/modules/course/quizResultContainer'
export default {
  components: { Paginate },
  data () {
    return {
      filter: {
        pageNo: 1,
        pageSize: 3,
        type: '2'
      },
      examList: [],
      pages: 0
    }
  },
  created () {
    this.getUserExams(this.filter)
  },
  methods: {
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getUserExams(this.filter)
    },
    getUserExams (filter) {
      this.$api.post(this.$global.examApiPath, '/examPaper/searchByUserOnly', filter, r => {
        if (r.data && r.data.length>0) {
          this.examList = r.data
          this.pages = Math.ceil(r.cntData / this.filter.pageSize)
        } else {
          this.examList = []
          this.pages = 0
        }
      })
    },
    getPaperState (item) {
      switch (this.$utils.judgmentState(item.startDate, item.endDate)) {
        case '1': {
          return {
            code: '1',
            value: '问卷已结束'
          }
          break
        }
        case '2': {
          return {
            code: '2',
            value: '问卷未开放'
          }
          break
        }
        case '-1': {
          return {
            code: '-1',
            value: '问卷时间有误'
          }
          break
        }
        default: {
          return {
            code: '0',
            value: '开始回答'
          }
        }
      }
    },
    doQuestionnaire (item) {
      var path = (getCookie('org')) ? this.$OR.getUrl(getCookie('org').businessId) : ''
      this.$api.post(this.$global.examApiPath, '/examExamScore/getExamId', {paperId: item.id}, r => {
        if (r.data) {
          this.$router.push({
            path: path + '/questionnaireStart/' + r.data + '/0/' + item.id
          })
        }
      })
    },
    showQuizResult (item) {
      if (getCookie(process.env.TOKEN_KEY)) {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '测验结果',
            styles: {
              width: '812',
              height: String(0.8242 * window.screen.availHeight)
            },
            offEdit: true, // 是否包含"确定"与"取消"按钮
            currentComponent: {
              name: 'QuizResultBox',
              template: QuizResultContainer,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: {
                paperId: item.id,
                examId: item.examIdFinish
              }
            },
            closed () {
            }
          }
        })
      } else {
        this.$toasted.show('请登录', {
          duration: 800
        })
      }
    },
    examDetail (examId) {
      var path = (getCookie('org')) ? this.$OR.getUrl(getCookie('org').businessId) : ''
      this.$router.push({
        path: path + '/examResult/' + examId
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/quiz.vue